export const FETCH_ASSET_INQUIRIES_URL = `${process.env.REACT_APP_API_URL}/asset_inquiries`;
export const CREATE_ASSET_INQUIRIES_URL = `${process.env.REACT_APP_API_URL}/asset_inquiries/create`;
export const UPDATE_ASSET_INQUIRIES_URL = `${process.env.REACT_APP_API_URL}/asset_inquiries`;
export const DELETE_ASSET_INQUIRIES_URL = `${process.env.REACT_APP_API_URL}/asset_inquiries`;
